import { useContext } from 'react'
import GlobalsContext from 'sb-hooks/GlobalsContext'


const useFeatures = () => {
  const { globals = {} } = useContext(GlobalsContext)
  const { features = {} } = globals || {}

  return features
}


export default useFeatures
